import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = `${API}/api/uploads/navanaa_logo_clean.png`;

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${API}/api/admin/login`, { email, password }, { withCredentials: true });
      navigate('/admin/dashboard');
    } catch (_err) {
      setError('Invalid email or password. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="admin-page admin-login" data-testid="admin-login-page">
      <div className="admin-login-card">
        <img src={LOGO_URL} alt="Navanaa Estate" className="admin-login-logo" data-testid="admin-login-logo" />
        <p>Content Management System</p>
        {error && <div className="admin-login-error" data-testid="admin-login-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <input type="email" placeholder="Email address" value={email} onChange={e => setEmail(e.target.value)} required data-testid="admin-email-input" />
          <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required data-testid="admin-password-input" />
          <button type="submit" disabled={loading} data-testid="admin-login-btn">{loading ? 'Signing in...' : 'Access Dashboard'}</button>
        </form>
      </div>
    </div>
  );
}
